import { Box, Divider, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import GroupsIcon from "@mui/icons-material/Groups";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import variables from "../../../../assets/styles/variables.module.scss";

import { useDispatch } from "react-redux";
import BaseInstance from "../../../../Services/AxiosInstance/BaseInstance";
import {
  StartLoading,
  StopLoading,
} from "../../../Store/LoadingReducer/LoaderActions";
import {
  DASHBOARD_AGENT,
  DASHBOARD_TEAMS,
} from "../../../../Services/Endpoint";
import { ShowError } from "../../../Store/MessageReducer/MsgActions";
import { DashboardStats } from "../../../Types/Dashboard";
import { useNavigate } from 'react-router-dom';

interface MyComponentProps {
  dashboardStats: DashboardStats
}

const SmallCardAgent: React.FC<MyComponentProps> = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();



  return (
    <Paper
      onClick={() => navigate('/dashboard-analytics')}
      sx={{
        borderRadius: "12px",
        p: 3,
        display: "flex",
        flexDirection: "column",
        background: "#02bedb",
        color: variables.whiteColor,
        height: "100%",
        boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
        cursor: 'pointer', 
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      <Box display="flex" alignItems="center" mb={2}>
        <GroupsIcon sx={{ mr: 1 }} />
        <Typography variant="subtitle1" fontWeight={600}>
          My Agents & Teams
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{
            textTransform: "uppercase",
            letterSpacing: "0.5px", // Optional: adds better spacing for uppercase text
          }}
        >
          Total Agents
        </Typography>
        <Typography variant="h4" fontWeight={700}>
          {props.dashboardStats.agents.total_agents}
        </Typography>
      </Box>

      <Divider sx={{ backgroundColor: variables.whiteColor, my: 1 }} />

      <Box display="flex" alignItems="center" mb={1}>
        <Typography variant="body2" sx={{ flex: 1 }}>
          Active Teams
        </Typography>
        <Typography variant="body2" fontWeight={700}>
          {props.dashboardStats.teams.active_teams}
        </Typography>
      </Box>

      <Box display="flex" justifyContent="space-between" fontSize="12px">
        <Typography variant="caption">Own:  {props.dashboardStats.agents.own_agents}</Typography>
        <Typography variant="caption">Shared: {props.dashboardStats.agents.shared_agents}</Typography>
      </Box>
    </Paper>
  );
};

export default SmallCardAgent;
